import { AxiosPutMethod } from "../helpers/customAxios";
import { setShowPreloader } from "../store/activePage";
import HandleLogout from "./handleLogout";

const handleUpdateWalletStatus = async (body, dispatch) => {
  dispatch(setShowPreloader(true));
  const updateWallet = await AxiosPutMethod("org/wallet/update", body);
  dispatch(setShowPreloader(false));
  if (updateWallet?.status === 200) {
    return updateWallet;
  } else {
    if (updateWallet?.status === 401) HandleLogout();
    return null;
  }
};

export default handleUpdateWalletStatus;
